import { render, staticRenderFns } from "./EventModalCatalogUploadFile.vue?vue&type=template&id=72fa52a6&scoped=true"
import script from "./EventModalCatalogUploadFile.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogUploadFile.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogUploadFile.vue?vue&type=style&index=0&id=72fa52a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa52a6",
  null
  
)

export default component.exports